import Account from "byzantine/src/Account";
import { useMemo } from "react";

export function calculateBalanceTotal(
  depositAccounts: Account[],
  nonHiddenDepositAccounts: Account[],
  showHidden: boolean
) {
  const accounts = depositAccounts.filter(
    (acc) => ![...Account.PRODUCT_GROUPS.CDs].includes(acc.product_type)
  );
  let totalBalance = 0;
  if (showHidden) {
    totalBalance = accounts.reduce(
      (total, currentValue) => total + currentValue.availableBalanceAsFloat(),
      0
    );
  } else {
    totalBalance = nonHiddenDepositAccounts.reduce(
      (total, currentValue) => total + currentValue.availableBalanceAsFloat(),
      0
    );
  }
  return totalBalance;
}

export function filterDepositAccounts(depositAccounts: Account[]) {
  return depositAccounts.filter(
    (acc) =>
      acc.hidden === false &&
      ![...Account.PRODUCT_GROUPS.CDs].includes(acc.product_type)
  );
}

export function useAccountsTotal(
  depositAccounts: Account[],
  nonHiddenDepositAccounts: Account[],
  showHidden: boolean
) {
  return useMemo(
    () =>
      calculateBalanceTotal(
        depositAccounts,
        nonHiddenDepositAccounts,
        showHidden
      ),
    [depositAccounts, nonHiddenDepositAccounts, showHidden]
  );
}
